import { TicketIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Ticket = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <TicketIcon size={Sizes[size]} color={fill} {...rest} />;
};

Ticket.displayName = 'Ticket';
